// extracted by mini-css-extract-plugin
export default {"mainHeader":"AllNotes_mainHeader__Nsuec","concepts":"AllNotes_concepts__9ccXI"};